
import { Component, Prop, Vue } from 'vue-property-decorator'
import KAMReadOnlyForm from '@/views/kam/forms/KAMReadOnlyForm.vue'

@Component({
  components: { 'kam-read-only-form': KAMReadOnlyForm }
})
export default class KAMGenericForm extends Vue {
  @Prop({ required: true }) answers!: Record<string, any>
  @Prop({ default: () => ({}) }) media!: Record<string, any>
}
